







import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class EventServiceName extends Vue {
  @Prop({ required: true }) serviceName!: string;
  @Prop({ required: true }) serviceMenuName!: string;
}
